const STYLES = {
  success: "bg-[#e5efe8] text-[#4e7b5b]",
  warning: "bg-[#fdf3e1] text-[#9a6a1f]",
  alert: "bg-[#fbeae8] text-[#d94f3d]",
  neutral: "bg-[#efece6] text-[#57534e]",
  brand: "bg-[#1b3b36] text-white",
};

export default function StatusPill({ tone = "neutral", children, testid }) {
  return (
    <span data-testid={testid} className={`pill ${STYLES[tone] || STYLES.neutral}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {children}
    </span>
  );
}
